module.exports = __webpack_public_path__ + "img/close.2799a94.png";